//@ts-ignore
import { useSortable } from "@dnd-kit/sortable";
//@ts-ignore
import { CSS } from "@dnd-kit/utilities";
import { tw } from "@careinfo/tailwind";
import SwitchButton from "../../components/SwitchButton";

export const SortableColumnItem = ({ col, enabled, onToggle }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: col.accessorKey });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={tw`flex items-center justify-between py-2 px-2 bg-white rounded border shadow-sm cursor-move`}
      >
      <div
        className={tw`cursor-move flex-1`}
        {...attributes}
        {...listeners}
      >
        <span className={tw`text-gray-700 text-sm`}>{col.header}</span>
      </div>

      <SwitchButton
        disabled={false}
        value={enabled}
        onChange={() => onToggle(col.accessorKey)}
      />
    </div>
  );
};
